import React from "react";

const PrivacyPolicy = () => {
    return (
        <div className="container mx-auto p-6">
            <h1 className="text-2xl font-bold mb-4">PRIVACY POLICY</h1>

            <p>
                At Zoy, We are committed to respect and protect the privacy of the users.
                This Privacy Policy explains how We process and treat Your data including
                Personal Data (defined below) when You visit{" "}
                <a href="https://zoypg.com" className="text-blue-500">
                    https://zoypg.com
                </a>{" "}
                and explains the rights that are available to You.
            </p>

            <h2 className="text-xl font-semibold mt-6">SCOPE OF PRIVACY POLICY</h2>
            <p>
                This Privacy Policy applies solely to the information collected through
                your access and use of the Website, and the Application.
            </p>

            <h2 className="text-xl font-semibold mt-6">
                WHAT IS PERSONAL DATA/INFORMATION?
            </h2>
            <p>
                Personal Data means any information that relates to a natural person,
                which, either directly or indirectly, in combination with other
                information available or likely to be available with a body corporate,
                is capable of identifying such person (“Personal Data/Personal
                Information”).
            </p>

            <h2 className="text-xl font-semibold mt-6">DATA THAT WE COLLECT</h2>
            <p>The types of Personal Data that we may receive, collect, store and process fall into the following categories:  </p>
            <h3 className="text-lg font-medium mt-4">
                Personal Information/ Personal Data that You provide to Us voluntarily
            </h3>
            <p>
                While using Application, You may voluntarily provide Personal Data. For
                example: for booking an Accommodation, You may provide personal
                information limited to Your email ID and phone number. The Personal
                Information collected is used solely for providing the services to you.
            </p>

            <table className="table-auto border-collapse border border-gray-400 mt-4">
                <thead>
                    <tr>
                        <th className="border border-gray-400 px-4 py-2">
                            Type of Information
                        </th>
                        <th className="border border-gray-400 px-4 py-2">Contents</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td className="border border-gray-400 px-4 py-2">
                            Personal Details
                        </td>
                        <td className="border border-gray-400 px-4 py-2">
                            Mobile Number and Email ID as voluntarily submitted by You while
                            booking a request for demo.
                        </td>
                    </tr>
                    <tr>
                        <td className="border border-gray-400 px-4 py-2">IP Address</td>
                        <td className="border border-gray-400 px-4 py-2">
                            IP address to redirect to website hosted in India.
                        </td>
                    </tr>
                </tbody>
            </table>
            <div>
                <p>
                    We do not collect any information about Your race or ethnicity, religious or philosophical beliefs, sex life, sexual orientation, political opinions, trade union membership, information about Your health, genetic, or any information about criminal convictions and offences.
                    Furthermore, Your access and utilisation of the Website does not involve or create a situation of interception or recording of oral or electronic communications of the User.
                    We display personal testimonials and/or reviews of Members on Our Website in addition to other endorsements. If You wish to update or delete Your testimonial, You can contact Us at <a> +91 9686577377.</a>
                </p>
            </div>

            <h2 className="text-xl font-semibold mt-6">
                NON-PERSONAL INFORMATION THAT WE COLLECT
            </h2>
            <h3 className="text-lg font-medium mt-4">Log Files</h3>
            <p>
                We follow a standard procedure of using log files. Our website and
                applications use logs to see how many people visit them and what they do
                on the website. This information includes the person's IP address, what
                browser they were using, what ISP they were using, and when the visit
                occurred. These are not linked to any information that can identify an
                individual and therefore is treated as Non-Personal Information under
                this Policy. The purpose of this information is to help us analyse how
                people are using the website, and to see how users are moving around it.
            </p>

            <h3 className="text-lg font-medium mt-4">Cookies</h3>
            <p>
                Cookies are small bits of data we store on the device you use to access
                our Website which includes non-personal usage data about You. This
                includes user preferences, such as your default language, in cookies to
                personalize the content you see and to improve our services. Other
                examples include usage trends of Our Website, to track referral data, as
                well as to occasionally display different versions of content to You.
            </p>
            <p>
                You can also disable cookies to prevent Your browser from giving Us
                information, however, if You do, certain features of Our Website may not
                work properly.
            </p>

            <h3 className="text-lg font-medium mt-4">Analytics & Tracking</h3>
            <p>
                Zoy uses analytics and tracking technology services provided by third
                parties. These services are used to collect information such as browser
                type, to track the number of visitors to the website and to get a general
                understanding of how Our visitors access the Website. Following is a list
                of data we receive from such third-party service providers:
            </p>

            <table className="table-auto border-collapse border border-gray-400 mt-4">
                <thead>
                    <tr>
                        <th className="border border-gray-400 px-4 py-2">Serial No.</th>
                        <th className="border border-gray-400 px-4 py-2">
                            Type of Information
                        </th>
                        <th className="border border-gray-400 px-4 py-2">Contents</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td className="border border-gray-400 px-4 py-2">1</td>
                        <td className="border border-gray-400 px-4 py-2">
                            App related information (anonymised)
                        </td>
                        <td className="border border-gray-400 px-4 py-2">
                            App downloads, installs, uninstalls, session duration, user
                            engagement with specific features, ad clicks, location data, custom
                            events, crash reports, and User demographic details.
                        </td>
                    </tr>
                    <tr>
                        <td className="border border-gray-400 px-4 py-2">2</td>
                        <td className="border border-gray-400 px-4 py-2">
                            Browser and device data (anonymised)
                        </td>
                        <td className="border border-gray-400 px-4 py-2">
                            Browser information, Device type, Device model, Operating System
                        </td>
                    </tr>
                    <tr>
                        <td className="border border-gray-400 px-4 py-2">3</td>
                        <td className="border border-gray-400 px-4 py-2">
                            Usage Data (anonymised)
                        </td>
                        <td className="border border-gray-400 px-4 py-2">
                            Pageviews, Pages visited, Time spent on page, number of active
                            Users
                        </td>
                    </tr>
                </tbody>
            </table>
            <div>
                If You provide Personal Data to other third parties, it would be governed by their privacy policies and terms of use. We are not responsible for the privacy and security practices of these other websites or services. We encourage you to learn about these other websites’ privacy and security policies before providing them with your Personal Information.
            </div>
            <h2 className="text-xl font-semibold mt-6">YOUR CONSENT</h2>
            <p>
                By using or accessing Our Website and submitting your Personal Data to
                Us, You acknowledge that You accept and consent to this Privacy Policy.
                If You do not accept the terms of this Policy, You may either opt out or
                address any specific concerns regarding this Policy by writing to Us at{" "}
                <a href="mailto:vijaykumarm@zoypg.com" className="text-blue-500">
                    vijaykumarm@zoypg.com
                </a>
            </p>
            <h2 className="text-xl font-semibold mt-6">NON-PERSONAL INFORMATION DATA STORAGE   </h2>
            <p>
                Log files and Cookies gathered as mentioned above will only be kept for a maximum duration of 1 (one) year. The retention duration for third-party cookies is specified in their privacy policy, which can be accessed via the provided hyperlink in the table above.
            </p>


            <h2 className="text-xl font-semibold mt-6">PURPOSE OF COLLECTION</h2>
            <p>The collected information shall be used for the following purposes:</p>
            <ul className="list-disc ml-6">
                <li>Contact you for service/product-related queries in case You have submitted information as part of a sales query.</li>
                <li>
                    Contact you for advertising our services or sharing updates with You.
                    We will only do this when information is provided by you voluntarily while accessing the Website.
                    You may opt out at any time by contacting{" "}
                    <a href="mailto:vijaykumarm@zoypg.com" className="text-blue-500">vijaykumarm@zoypg.com</a>.
                </li>
                <li>Meeting legal and regulatory requirements. For example, to comply with a valid legal subpoena, request, or other lawful process that meets the regulatory requirements or that we otherwise determine is necessary to respond to.  </li>
                <li>Establish, exercise, or defend legal claims.</li>
                <li>
                    Corporate reorganisation: In the event of a corporate sale, merger, reorganization, dissolution, acquisition or similar event, any personal information and other data We process from You may become part of the assets We transfer or share in preparation for any such transaction. Any acquirer or successor of Zoy shall continue to process personal information consistent with this Policy.
                </li>
            </ul>

            <h2 className="text-xl font-semibold mt-6">LEGAL BASIS OF PROCESSING</h2>
            <p>We rely on the following legal bases for processing Your Personal Data:</p>
            <ul className="list-disc ml-6">
                <li><strong>Consent:</strong> Where we have express consent from You to process Your Personal Data.</li>
                <li>
                    <strong>Legitimate business interest:</strong>  This refers to the interest in conducting and managing Our business. We ensure to consider and balance any potential impact on You (both positive and negative) and Your rights before We process Your Personal Data for Our legitimate interests. You can find out more about how We assess Our legitimate interests in relation to the potential impact of certain activities by contacting Us.
                </li>
                <li>
                    <strong>To comply with a legal obligation:</strong> This means processing Your Personal Data if it is necessary to fulfil a legal obligation imposed on Us or defending any claim against us relating to Your Personal Information. To comply with a valid legal subpoena, request, or other lawful process that meets the regulatory requirements or that we otherwise determine is necessary to respond to.
                </li>
            </ul>

            <h2 className="text-xl font-semibold mt-6">DISCLOSURE OF YOUR PERSONAL DATA</h2>
            <p>
                The Personal Information you provide to us may be hosted on servers located in Mumbai, India, operated by AWS cloud servers located in India. By providing your Personal Information, you consent to the transfer and hosting of such information on servers located in these jurisdictions. We disclose Personal Information shared by you to Zoy for recording and managing details you have provided for Zoy’s use. We require you_ to respect your privacy and keep your personal data safe, confidential and to only be used for specific purpose it was disclosed and in accordance with Our instructions. We ensure that Your Personal Information is not shared with any other third party.
            </p>
            <p>We ensure that Your Personal Information is not shared with any third party.</p>

            <h2 className="text-xl font-semibold mt-6">NO SALE OF DATA</h2>
            <p>We do not sell Your personal information to any third parties and have not undertaken any such sale within the preceding 12 months.</p>

            <h2 className="text-xl font-semibold mt-6">SOCIAL MEDIA FEATURES</h2>
            <p>
                Our websites includes social media links and the Use of these features may allow those websites to collect your IP address, detect which page you are visiting on our site, and set a cookie to enable the feature to function properly. Your interactions with these features are governed by the privacy policy of those third party providing it.
            </p>

            <h2 className="text-xl font-semibold mt-6">YOUR LEGAL RIGHTS</h2>
            <p>
                The rights provided hereunder apply to You according to the data protection laws of the country which You are based on. In the situation You would like to access, rectify, erase, restrict or object to processing, or exporting Your Personal Data, We will extend Our sincere support to in responding to Your request within a reasonable timeframe.
            </p>
            <ul className="list-disc ml-6">
                <li >
                    If you make a request or would like to exercise any of the rights mentioned below, please contact us at{" "}
                    <a href="mailto:vijaykumarm@zoypg.com" className="text-blue-500">vijaykumarm@zoypg.com</a>.
                </li>
            </ul>

            <h3 className="text-lg font-medium mt-4">Your Rights Include:</h3>
            <ul className="list-disc ml-6">
                <li>
                    <strong>Right of access:</strong> You have the right to access and obtain a copy of Your Personal Data that We hold. You may also be informed about the information's source, period and purpose of processing, and the parties to whom the information is shared if requested by You.
                </li>
                <li>
                    <strong>Right to request deletion:</strong>When it is no longer necessary for the purposes for which Your Personal Data was originally collected, You have the right to request that We delete Your Personal Data or in any other situation you deem fit, unless permitted by applicable law.
                </li>
                <li>
                    <div className=" bg-blue-50 p-4 my-4">
                        <p className="text-blue-700 font-semibold">Note:</p>
                        <p className="text-blue-700">
                            You may also designate an authorized agent to submit a request on Your behalf to access or delete Your personal information.
                            To do so, You must:
                        </p>
                        <ol className="list-decimal ml-6 text-blue-700">
                            <li>Provide that authorized agent with written and signed permission to submit such request.</li>
                            <li>Verify Your own identity directly with Us.</li>
                        </ol>
                    </div>
                </li>
                <li>
                    <strong>Right to lodge complaint with the regulator:</strong> You have the right to complain to the appropriate supervisory authority
                    if You have any grievance regarding the collection, use, or sharing of Your Personal Data by Us.
                </li>
                <li>
                    <strong>Right to rectification:</strong> You have the right to revise the information We hold about You or to remedy any inaccuracies. Based on the purpose for which We use Your information, You may intimate Us to either add additional information about You in Our database or correct any wrong information We may have about You on Our database.
                </li>
                <li>
                    <strong>Right to restrict processing:</strong> You may also have the right to request to restrict the use of Your Personal Data in certain circumstances, such as when You have objected to Our use of Your Personal Data but We need to verify whether We have overriding legitimate grounds to use it.
                </li>
                <div className=" bg-blue-50 p-4 my-4">
                    <p className="text-blue-700 font-semibold">Note:</p>
                    <p className="text-blue-700">
                        If You revoke Your consent, We will stop processing the personal data as soon as practicable but not later than 30 days after receiving the request.
                    </p>
                </div>
                <li>
                    <strong>Right to object to processing:</strong>  You have the right to oppose to the use of Your Personal Data in certain circumstances, such as the use of Your Personal Data for a task carried out in the public interest; the exercise of official authority vested in you; direct marketing or your legitimate interests (or those of a third party).
                </li>
                <li>
                    <strong>Right in relation to automated decision-making and profiling:</strong> You have the right not to be subjected to automated processing that significantly influences a decision.
                </li><strong>Please note that we do not undertake profiling based on Your Personal Data. </strong>
                <li><strong>Right to Non-Discrimination:</strong> We will not discriminate against You for exercising Your rights.</li>
            </ul>
            <h2 className="text-xl font-semibold mt-6">OPTING OUT OF MARKETING</h2>
            <p>
                Users who have provided their information and registered on the Website have opted in to receive promotional emails and newsletters from time to time.
                Users can unsubscribe from mail threads in the following ways:
            </p>
            <ul className="list-disc ml-6">
                <li>Reply to the mail thread sent by Us stating that You wish to unsubscribe.</li>
                <li>You may unsubscribe from Our newsletters by clicking on the 'unsubscribe' option that is available in the newsletter.</li>
                <li>Write to us at <a href="mailto:vijaykumarm@zoypg.com" className="text-blue-500">vijaykumarm@zoypg.com</a>.</li>
            </ul>

            <h2 className="text-xl font-semibold mt-6">DATA INTEGRITY AND SECURITY</h2>
            <p>
                We are ISO 27001 certified and also have a SOC2 Type 1 certification with respect to Our information security practices and infrastructure.
                Furthermore, Our system is configured with data encryption, or scrambling technologies and firewalls constructed to the highest industry standards.
                We also use Secure Socket Layer (SSL) technology that protects the data you send over the internet.
            </p>
            <p>
                We recommend that You use the latest available versions of browsers in order to take advantage of updates in security technology.
                Although We strive to protect Your information, no data transmission over the Internet is completely secure.
                There is some risk associated with any data transmission, including the risk that Personal Data may be intercepted in transit.
                Therefore, We cannot guarantee its absolute security. However, We have put in place necessary procedures to deal with any suspected or possible breaches of Personal Data
                and will immediately notify You and any applicable regulatory authority of a breach where We are legally required to do so.
            </p>

            <h2 className="text-xl font-semibold mt-6">DATA RETENTION</h2>
            <p>
                We retain your data for as long as necessary to fulfill the purposes outlined in this Privacy Policy unless a longer retention period is required by law.
                You may request the deletion of your data at any time, and we will promptly take appropriate measures to delete it from our records.
            </p>

            <h2 className="text-xl font-semibold mt-6">DISPOSAL</h2>
            <p>
                When the purpose of processing your personal data is accomplished, we ensure safe disposal of documents that contain Your personal identifying information.
                Paper or electronic documents no longer required are destroyed by shredding, erasing, or otherwise modifying the personal identifying information
                to make it unreadable or indecipherable through any means.
            </p>

            <h2 className="text-xl font-semibold mt-6">CHILDREN’S PRIVACY</h2>
            <p>
                Our website and services are not directed to children under the age of 18 or 16 (depending on the jurisdiction you are accessing this Policy from),
                and Zoy will never knowingly collect personal or other information from anyone it knows is under the age of 18 or 16.
            </p>
            <p>
                We recommend that persons under 18 years of age ask their parents for permission before using our Website or services or sharing any information about themselves with Us.
            </p>
            <p>
                To the extent we have actual knowledge that we collect or maintain personal information of a minor under age 16, those minors between the age of 13 and 16
                must opt in to any sales of personal information (as defined under applicable law), and minors under the age of 13 must have a parent consent to sales of personal information.
                All minors have the right to opt-out later at any time.
            </p>

            {/* Highlighted Note with Border */}
            <div className="border-l-4 border-red-500 bg-red-50 p-4 my-4">
                <p className="text-red-700 font-semibold">Important Note:</p>
                <p className="text-red-700">
                    It is assumed that the Users who provide Personal Information are aged 18 and above unless accompanied by parental consent.
                    We do not knowingly gather Personal Information from individuals under the age of 18.
                    In the event that we become aware of an individual under 18 providing us with Personal Information, we will promptly take appropriate measures to remove it.
                </p>
            </div>

            <h2 className="text-xl font-semibold mt-6">COMPLIANCE WITH THIS PRIVACY POLICY</h2>
            <p>
                We ensure that Personal Data You provide is used in conformity with this Policy and take up periodic reviews to ensure this.
                Zoy regularly verifies that the contents of this Policy are accurate, detailed, and contemporary for the types of information and data intended to be covered.
            </p>
            <p>
                If You have any grievances about Our adherence to this Policy or the manner in which Your Personal Data is used, kindly write to Us at{" "}
                <a href="mailto:vijaykumarm@zoypg.com" className="text-blue-500">vijaykumarm@zoypg.com</a>.
                We shall contact You, and if necessary, cooperate and engage with the appropriate regulatory authorities to ensure that your grievances are addressed effectively.
            </p>

            <h2 className="text-xl font-semibold mt-6">CHANGES OR MODIFICATIONS</h2>
            <p>
                Zoy reserves the right to change this Policy at any time.
                We may modify this Policy to reflect changes in the way We collect, use, or disclose information, or to reflect changes in privacy laws, regulations, and/or industry standards.
            </p>
            <p>
                We encourage Users to review this Policy when accessing the Website.
                If we make a material change to this Policy, we will provide You with appropriate notice.
            </p>

        </div>
    );
};

export default PrivacyPolicy;
